module.exports = __webpack_public_path__ + "static/media/index.31af92cd.styl";